export const ID = 'id';
export const AFFILIATE = 'affiliateId';
export const APPLICATION = 'applicationId';
export const NETWORK = 'networkId';
export const PLATFORM = 'platformId';
export const LOCALE = 'localeId';
export const DOMAIN = 'domainId';
export const LINK_TYPE_ID = 'linkTypeId';
export const CONVERSION_PAGE_FLOW = 'conversionPageFlowId';
export const CONVERSION_PAGES = 'conversionPageIds';
export const COUNTRY = 'countryId';
export const DEEP_LINK = 'deeplink';
export const OWNERS = 'owners';
export const CAMPAIGNS = 'campaigns';
export const PARENT_CAMPAIGN = 'parentCampaign';
export const NAME = 'name';
export const SPEND_ALLOCATION_TYPE = 'spendAllocationType';

export const MEDIA_SOURCE = 'mediaSource';
export const FRAUD_PROTECTIONS = 'fraudProtections';

export const MISSING_MEDIA_SOURCE = 'missingMediaSource';

export const TYPE = 'targetingActivityType';
export const ACTIVITY_TYPE = 'activityType';

export const LABELS = 'labelIds';
export const PROMO_CODE = 'promocodeId';
export const LINK_FORMAT_TYPE = 'linkFormatType';
export const OWNER = 'currentOwnerId';

export const COST_MODELS = 'costModels';
export const REGISTRATIONS_FRAUD = 'registrationsFraud';
export const INSTALLS_FRAUD = 'installFraud';

export const LINK = 'link';
export const LINK_EXPIRATION_DATE = 'linkExpirationDate';

export const FRAUD_PROTECTION_COUNTRIES = 'countryIds';
export const FRAUD_PROTECTION_DEVICE_TYPE = 'deviceType';
export const FRAUD_PROTECTION_OS_VERSION = 'osVersion';
export const FRAUD_PROTECTION_OS_VERSION_OPERATOR = 'operator';
export const FRAUD_PROTECTION_OS_VERSION_VALUE = 'value';
export const FRAUD_PROTECTION_OS_VERSION_MAX_VALUE = 'maxValue';

export const TEST_CAMPAIGN_ID = 'testCampaignId';
export const TEST_CAMPAIGN_END_DATE = 'testCampaignEndDate';

export const CAMPAIGN_TYPE_RE_ENGAGEMENT = 2;

export const RE_ENGAGEMENT = 'isReEngagement';

export const REWARD_PACKAGE = 'rewardPackageId';
export const ADDITIONAL_REWARD_PACKAGE = 'additionalRewardPackageId';
export const ADDITIONAL_REWARD_CONDITION = 'additionalRewardConditionId';

export const ADDITIONAL_PARAMS = 'additionalParams';
export const CPP_PARAMS = 'customProductPageParams';

export const LINKS_CONFIG = 'linksConfig';

export const CAMPAIGN_LINK = 'campaignLink';
export const HYBRID_LINK = 'hybridLink';
export const CTV_LINK = 'ctvLink';
export const AGENCY_LINK = 'agencyLink';
export const PARTNER_NAME = 'partnerName';

export const CONVERSION_PAGE_ID = 'conversionPageId';

export const ADDITIONAL_PARAMS_FIELD = 'AdditionalParameters';
export const ANDROID_ADDITIONAL_PARAMS_FIELD = 'AndroidAdditionalParameters';
export const IOS_ADDITIONAL_PARAMS_FIELD = 'IosAdditionalParameters';

export const REWARD_FIELD = 'Reward';
export const ADDITIONAL_REWARD_FIELD = 'AdditionalReward';
export const ADDITIONAL_REWARD_CONDITION_FIELD = 'AdditionalRewardCondition';

export const ANDROID_CONVERSION_PAGE_FIELD = 'AndroidConversionPage';
export const IOS_CONVERSION_PAGE_FIELD = 'IosConversionPage';

export const ANDROID_CPP_FIELD = 'AndroidCPP';
export const IOS_CPP_FIELD = 'IosCPP';

export const PARTNER_NAME_FIELD = 'PartnerName';

export const TRACKING_TYPE = 1;
export const DEEP_TYPE = 2;
export const HYBRYD_TYPE = 3;
export const CTV_TYPE = 4;
export const AGENCY_TYPE = 5;

export const LINK_TYPE = 'linkType';
export const DEFAULT_TYPE = { id: 1, name: 'Tracking' };

export const RATE_VALUE = 'value';
export const RATE_CURRENCY = 'currency';
export const RATE_PERIOD = 'period';

export const TARGET_USERS_ALL_USERS = 3;
export const TARGET_USERS_AUDIENCE = 4;
